import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { Router } from 'react-router-dom';

import App from './App';
import GA from './lib/utils/ga';
import PostHog from './lib/utils/posthog';
import { history, store } from './store';

import 'react-popper-tooltip/dist/styles.css';
import './index.css';

const ga = new GA();
ga.init();

const posthog = new PostHog();
posthog.init();

ReactDOM.render(
  <Provider store={store}>
    <Router history={history}>
      <App />
    </Router>
  </Provider>,
  document.getElementById('root')
);

if (module.hot) {
  module.hot.accept(function (err) {
    console.log(err, 'An error occurred while accepting new version');
  });
}
